import {
  useWSModalCustom,
  WSForm,
  WSInputText,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import * as Yup from "yup";

type FormData = { name: string };

type Props = { count: number } & WSModalCustomProps<string>;

const ModalBulkRenameTransactions: React.FC<Props> = props => (
  <WSForm<FormData>
    onSubmit={formData => props.onClose(formData.name)}
    defaultValues={{ name: "" }}
    validationSchema={Yup.object().shape({
      name: Yup.string().required("Required").max(100, "Too long")
    })}
  >
    <WSModal
      title="Rename transactions"
      size="S"
      onClose={props.onClose}
      actions={{
        buttons: [
          {
            label: "Cancel",
            kind: "Secondary",
            type: "button",
            onClick: () => props.onClose("")
          },
          { label: `Rename ${props.count}` }
        ]
      }}
    >
      <WSList gap="M">
        <WSText color="gray500">
          Set the same description on the {props.count} selected transactions.
        </WSText>
        <WSForm.Field name="name" label="Description" component={WSInputText} />
      </WSList>
    </WSModal>
  </WSForm>
);

export const useModalBulkRenameTransactions = () =>
  useWSModalCustom(ModalBulkRenameTransactions);
